const entryType = 'navigation';

const CACHE_LIMIT_MS = 13;
const CDN_LIMIT_MS = 333;

export default function nav(window, performance) {
    return new Promise(resolve => {
        window.addEventListener('load', () => {
            setTimeout(() => {
                let navigation = performance.getEntriesByType && performance.getEntriesByType(entryType)[0];
                let result;
                if (!navigation) {
                    navigation = performance.timing;
                    const time = t => t - navigation.navigationStart;
                    result = {
                        entryType,
                        duration: time(navigation.loadEventEnd),
                        dns: navigation.domainLookupEnd - navigation.domainLookupStart,
                        ttfb: time(navigation.responseStart),
                        ttlb: time(navigation.responseEnd),
                        dcl: time(navigation.domContentLoadedEventEnd)
                    };
                } else {
                    const {round} = Math;
                    result = {
                        entryType,
                        type: navigation.type,
                        duration: round(navigation.duration),
                        dns: round(navigation.domainLookupEnd - navigation.domainLookupStart),
                        ttfb: round(navigation.responseStart),
                        ttlb: round(navigation.responseEnd),
                        dcl: round(navigation.domContentLoadedEventEnd),
                        transferSize: navigation.transferSize,
                        decodedBodySize: navigation.decodedBodySize,
                        protocol: navigation.nextHopProtocol
                    };
                }
                result.caching = determineCaching(navigation);
                const {document: {referrer}, location} = window;
                result.url = fixURL(location.href, true);
                if (referrer) {
                    result.referrer = fixURL(referrer, false);
                }
                resolve(result);
            });
        }, {
            once: true,
            passive: true
        });
    });
}

function determineCaching({requestStart, responseStart, responseEnd, transferSize, encodedBodySize}) {
    if (typeof transferSize === 'number') {
        if (transferSize === 0) {
            return 'browser';
        }
        if (transferSize < encodedBodySize) {
            return 'eTag';
        }
    } else {
        if (responseStart - requestStart < CACHE_LIMIT_MS) {
            return 'browser';
        }
        if (responseEnd - responseStart < CACHE_LIMIT_MS) {
            return 'maybe eTag';
        }
    }
    if (responseEnd - responseStart < CDN_LIMIT_MS) {
        return 'maybe CDN';
    }
    return 'unknown';
}

function fixURL(url, args) {
    const e = /^https?:\/\/(?:www\.)?(.*)/.exec(url);
    if (!e) {
        return url;
    }
    const short = e[1];
    return args || !short ? short : short.replace(/\?.*$/, '');
}
